<template>
    <div class="top-bar">
        <div class="container">
            <div class="logo cursor" @click="$router.push('/')">
                <img src="../assets/img/logo.png" alt="福分通">
            </div>
            <div class="top-nav">
                <ul>
                    <li><a href="http://www.fufentong.com/">福分通商城</a></li>
                    <li v-if="username"><a href="/index.html">{{username}}</a></li>
                    <li v-else><a href="login.html">企业登录/注册</a></li>
                    <!-- 不要写死 将来必改 -->
                    <!-- <li><a href="/user/clogin.html">员工登录</a></li>
                    <li><a href="/user/card-login.html">卡券兑换</a></li> -->
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "top",
        computed:{
            username(){
                if (this.storage.getStorage('company_invoice_info')){
                    return this.storage.getStorage('company_invoice_info').company
                }
            }
        }
    }
</script>

<style scoped lang="stylus">
    .top-bar
        width 100%
        min-width 1200px
        height 60px
        line-height 60px
        background-color rgba(0, 0, 0, 0.5)
        position absolute
        top 0
        z-index 1
        border-bottom 1px solid #8d8888
        .logo
            display inline-block
        .top-nav
            float right
            li
                display inline-block
                margin-left 45px
                a
                    display block
                    font-size 14px
                    font-weight bold
                    color white
                    &:hover
                        color #0089ff
</style>